import React, { useEffect, useRef, useState } from 'react';
import CloudUploadRoundedIcon from '@mui/icons-material/CloudUploadRounded';
import { Typography } from '@mui/material';
import RcTooltip from 'rc-tooltip';
import InsertLinkRoundedIcon from '@mui/icons-material/InsertLinkRounded';
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import CustomTypography from '@src/new-components/Typography';
import NewFeature from '@src/new-components/Chip/NewFeature';
import { COLOR } from '@src/styles/color';
import { useTranslation } from 'react-i18next';
import {
  StyledItem,
  StyledOptionCreateProject,
  StyledProjectInputItem,
} from './index.style';

const ICONS = {
  CreateProjectIcon: <AddRoundedIcon sx={{ color: COLOR.navyBlue }} />,
  UploadFileIcon: <CloudUploadRoundedIcon sx={{ color: COLOR.navyBlue }} />,
  WebLinkIcon: <InsertLinkRoundedIcon sx={{ color: COLOR.navyBlue }} />,
};
const ProjectInputItem = ({
  title,
  logo,
  option,
  onSelect,
  disabled,
  isNewFeature,
  newUiProjectsEnabled,
  subText,
  subOptions,
}) => {
  const { t } = useTranslation();

  const [isTooltipOpen, setIsTooltipOpen] = useState(false);

  const containerRef = useRef(null);

  const handleClickOutside = (event) => {
    if (event.target.id === 'option-create-project') return;
    if (containerRef.current && !containerRef.current.contains(event.target)) {
      setIsTooltipOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleToggle = () => {
    if (disabled) return;

    if (newUiProjectsEnabled && subOptions?.length > 0) {
      setIsTooltipOpen(!isTooltipOpen);
    } else {
      onSelect(title, option);
    }
  };

  const handleSubOptionClick = (e, subOption) => {
    e.stopPropagation();
    e.preventDefault();
    onSelect(title, subOption);
    setIsTooltipOpen(false);
  };

  return (
    <StyledProjectInputItem
      ref={containerRef}
      newUiProjectsEnabled={newUiProjectsEnabled}
      isTooltipOpen={isTooltipOpen}
    >
      <div
        role="button"
        className="img-wrapper"
        tabIndex="0"
        onClick={handleToggle}
        style={{
          opacity: disabled ? 0.5 : 1,
          cursor: disabled ? 'not-allowed' : 'pointer',
          pointerEvents: disabled ? 'none' : 'auto',
        }}
      >
        <div className="img-item">
          <img src={logo} alt={title} />
          {newUiProjectsEnabled && (
            <RcTooltip
              placement="bottomLeft"
              overlay={
                <StyledOptionCreateProject
                  id="option-create-project"
                  onClick={(e) => e.stopPropagation()}
                  onMouseDown={(e) => e.stopPropagation()}
                >
                  {subOptions?.map((subOption) => (
                    <StyledItem
                      key={subOption.label}
                      onClick={(e) => handleSubOptionClick(e, subOption)}
                      onMouseDown={(e) => e.stopPropagation()}
                      id="option-create-project"
                    >
                      {ICONS[subOption?.icon]}
                      <CustomTypography
                        variant="body-14-medium"
                        color={COLOR.descriptionGray}
                      >
                        {t(subOption.label)}
                      </CustomTypography>
                    </StyledItem>
                  ))}
                </StyledOptionCreateProject>
              }
              trigger={[]}
              visible={isTooltipOpen}
              onVisibleChange={(visible) => {
                if (!visible) setIsTooltipOpen(false);
              }}
              showArrow={false}
              align={{ offset: [0, 5] }}
            >
              <div className="btn-plus" style={{ pointerEvents: 'none' }}>
                <AddRoundedIcon
                  sx={{ width: 24, height: 24, color: COLOR.white }}
                />
              </div>
            </RcTooltip>
          )}
        </div>
      </div>
      <div className="title-wrapper">
        <Typography className="card-title">{title}</Typography>
        {isNewFeature && <NewFeature />}
      </div>
      {subText && (
        <CustomTypography
          variant="body-12-regular"
          color={COLOR.descriptionUpload}
        >
          {subText}
        </CustomTypography>
      )}
    </StyledProjectInputItem>
  );
};

export default ProjectInputItem;
